import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { Layout, Menu } from 'antd';
const { Sider } = Layout;
import type { MenuProps } from 'antd';

import {
    MdSpaceDashboard,
    MdChatBubbleOutline,
    MdSupervisedUserCircle,
    MdLocationPin,
    MdPersonPin,
    MdGroup,
    MdOutlineFilterBAndW,
    MdSupportAgent,
    MdOutlineReceiptLong,
    MdPolyline,
    // MdOutlineDataUsage,
} from 'react-icons/md';
import { url } from '@app/utils/constants';
import Logo from '@images/logo.png';
import LogoSmall from '@images/logo-small.png';
import useMe from '@app/hooks/auth/useMe';

type MenuItem = Required<MenuProps>['items'][number];

export type HeaderProps = {
    defaultOpen?: boolean;
    showHandle?: boolean;
    onLogin?: () => void;
    onLogout?: () => void;
    onCreateAccount?: () => void;
    onHandleClick?: () => void;
    onLogoClick?: () => void;
};

export const Header = (props: HeaderProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(false);
    const { data: me } = useMe();

    const navLinks: MenuItem[] = [
        {
            key: url.adminPortal.dashboard,
            label: 'Dashboard',
            icon: <MdSpaceDashboard />,
            onClick: () => navigate(url.adminPortal.dashboard),
        },
        {
            key: url.adminPortal.interactions,
            label: 'Interactions',
            icon: <MdChatBubbleOutline />,
            onClick: () => navigate(url.adminPortal.interactions),
        },
        {
            key: url.adminPortal.contacts,
            label: 'Contacts',
            icon: <MdGroup />,
            onClick: () => navigate(url.adminPortal.contacts),
        },
        me?.is_internal
            ? {
                  key: 'internal-admin',
                  label: 'Internal Admin',
                  type: 'group',
                  children: [
                      {
                          key: url.adminPortal.internalAdmin.clients.list,
                          label: 'Clients',
                          icon: <MdPersonPin />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.clients.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.channelPartners.list,
                          label: 'Channel Partners',
                          icon: <MdSupervisedUserCircle />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.channelPartners.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.brands.list,
                          label: 'Brands',
                          icon: <MdOutlineFilterBAndW />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.brands.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.locations.list,
                          label: 'Locations',
                          icon: <MdLocationPin />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.locations.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.assignAgent.list,
                          label: 'AI Agents',
                          icon: <MdSupportAgent />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.assignAgent.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.agentFlows.list,
                          label: 'AI Agent Flows',
                          icon: <MdPolyline />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.agentFlows.list);
                          },
                      },
                      {
                          key: url.adminPortal.internalAdmin.billingReports,
                          label: 'Billing Reports',
                          icon: <MdOutlineReceiptLong />,
                          onClick: () => {
                              navigate(url.adminPortal.internalAdmin.billingReports);
                          },
                      },
                      //   need to hide sidebar until we release officially....
                      //   {
                      //       key: url.adminPortal.internalAdmin.tokenUsage,
                      //       label: 'Token Usage',
                      //       icon: <MdOutlineDataUsage />,
                      //       onClick: () => {
                      //           navigate(url.adminPortal.internalAdmin.tokenUsage);
                      //       },
                      //   },
                  ],
              }
            : {
                  key: url.adminPortal.locations,
                  label: 'Locations',
                  icon: <MdLocationPin />,
                  onClick: () => navigate(url.adminPortal.locations),
              },
    ];

    const isAgentFlowsActive = location.pathname.startsWith(
        url.adminPortal.internalAdmin.agentFlows.list
    );

    const selectedKeys = isAgentFlowsActive
        ? [url.adminPortal.internalAdmin.agentFlows.list]
        : [location.pathname];

    return (
        <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            collapsedWidth={60}
            width={250}
            theme="light"
            id="site-sidebar"
            className="site-sidebar">
            <div className="header-logo">
                {collapsed ? (
                    <img src={LogoSmall} onClick={props.onLogoClick} className="logo" />
                ) : (
                    <img src={Logo} onClick={props.onLogoClick} className="logo" />
                )}
            </div>
            <Menu
                className="nav-menu"
                theme="light"
                selectedKeys={selectedKeys}
                mode="vertical"
                inlineIndent={16}
                items={navLinks}
            />
        </Sider>
    );
};
